// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brand-text{font-size:14px}.navbar-brand>.logo{margin-left:10px;max-height:30px;-o-object-fit:contain;object-fit:contain}.mobile-navbar-title{max-width:60px;max-height:24px;white-space:nowrap;overflow:hidden}", ""]);
// Exports
module.exports = exports;
